module.exports = __webpack_public_path__ + "static/sunsmart_3d.c59e0495.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project6/sunsmart_3d.jpg
// module id = 517
// module chunks = 111663361672460